import { render, staticRenderFns } from "./social-post.html?vue&type=template&id=7486efa1&scoped=true&"
import script from "./social-post.js?vue&type=script&lang=js&"
export * from "./social-post.js?vue&type=script&lang=js&"
import style0 from "./social-post.scss?vue&type=style&index=0&id=7486efa1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7486efa1",
  null
  
)

export default component.exports